var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var PARTNER_LENDERS_WITH_SHORTNAME = [
    { name: 'Adelaide Bank', shortName: 'ADE', id: 'adelaide_bank', isPartner: true },
    { name: 'AMP', shortName: 'AMP', id: 'amp', isPartner: true },
    { name: 'ANZ Bank', shortName: 'anz', id: 'anz_bank', isPartner: true },
    { name: 'Auswide Bank', shortName: 'auswide', id: 'auswide_bank', isPartner: true },
    { name: 'Bank Australia', shortName: 'BAU', id: 'bank_australia', isPartner: true },
    { name: 'Bank First', shortName: 'BF', id: 'bank_first', isPartner: true },
    { name: 'Bankwest', shortName: 'bankwest', id: 'bank_west', isPartner: true },
    { name: 'Bluebay Home Loans', shortName: 'BLB', id: 'bluebay_home_loans', isPartner: true },
    { name: 'Better Mortgage Mgmt', shortName: 'BMM', id: 'better_mortgage_mgmt', isPartner: true },
    { name: 'Bank of Melbourne', shortName: 'bom', id: 'bank_of_melbourne', isPartner: true },
    { name: 'Bank SA', shortName: 'BSA', id: 'bank_sa', isPartner: true },
    { name: 'Bluestone', shortName: 'BST', id: 'blue_stone', isPartner: true },
    { name: 'Commonwealth Bank', shortName: 'CBA', id: 'commonwealth_bank', isPartner: true },
    { name: 'Connective Home Loans', shortName: 'CHLA', id: 'connective_home_loans', isPartner: true },
    { name: 'Citibank', shortName: 'citibank', id: 'citi_bank', isPartner: true },
    { name: 'Click Loans', shortName: 'Click_loans', id: 'click_loans', isPartner: true },
    { name: 'Firstmac', shortName: 'FMC', id: 'first_mac', isPartner: true },
    { name: 'Gateway Bank', shortName: 'GCU', id: 'gateway_bank', isPartner: true },
    { name: 'Heritage', shortName: 'heritage', id: 'heritage', isPartner: true },
    { name: 'Better Choice', shortName: 'IDE', id: 'better_choice', isPartner: true },
    { name: 'ING', shortName: 'ing', id: 'ing', isPartner: true },
    { name: 'Laboratories Credit Union', shortName: 'LCU', id: 'laboratories_credit_union', isPartner: true },
    { name: 'LaTrobe', shortName: 'La_Trobe', id: 'la_trobe', isPartner: true },
    { name: 'Loanave', shortName: 'LOA', id: 'loanave', isPartner: true },
    { name: 'Macquarie', shortName: 'macquarie', id: 'macquarie', isPartner: true },
    { name: 'ME Bank', shortName: 'mebank', id: 'me_bank', isPartner: true },
    { name: 'MKM Capital', shortName: 'MKM', id: 'mkm_capital', isPartner: true },
    { name: 'My State Bank', shortName: 'mystate', id: 'my_state_bank', isPartner: true },
    { name: 'NAB', shortName: 'NAB', id: 'nab', isPartner: true },
    {
        name: 'Newcastle Permanent Building Society',
        shortName: 'newcastle',
        id: 'newcastle_permanent_building_society',
        isPartner: true,
    },
    { name: 'Paramount', shortName: 'PAM', id: 'paramount', isPartner: true },
    { name: 'Pepper', shortName: 'pepper', id: 'pepper', isPartner: true },
    { name: 'P&N Bank', shortName: 'pnbank', id: 'pn_bank', isPartner: true },
    { name: 'RESIMAC', shortName: 'Resimac', id: 'resimac', isPartner: true },
    { name: 'St George', shortName: 'stgeorge', id: 'st_george', isPartner: true },
    { name: 'Suncorp', shortName: 'suncorp', id: 'suncorp', isPartner: true },
    { name: 'Teachers Mutual', shortName: 'TMB', id: 'teachers_mutual', isPartner: true },
    { name: 'Virgin Money', shortName: 'VMY', id: 'virgin_money', isPartner: true },
    { name: 'Westpac Bank', shortName: 'Westpac', id: 'westpac_bank', isPartner: true },
    {
        name: 'Connective Home Loans Select ',
        shortName: 'CHLAB',
        id: 'connective_home_loans_select_adelaide',
        isPartner: true,
    },
];
export var PARTNER_LENDERS_WITHOUT_SHORTNAME = [
    { name: 'Pacific Mortgage Group', shortName: '', id: 'pacific_mortgage_group', isPartner: true },
    { name: 'Gateway Credit Union', shortName: '', id: 'gateway_credit_union', isPartner: true },
];
export var PARTNER_LENDERS = __spreadArray(__spreadArray([], PARTNER_LENDERS_WITH_SHORTNAME, true), PARTNER_LENDERS_WITHOUT_SHORTNAME, true);
export var NON_PARTNER_WITH_SHORTNAME = [
    { name: 'AAMI', shortName: 'AAMI', id: 'aami', isPartner: false },
    { name: 'AAPBS Settlements Services', shortName: 'AAPBS', id: 'aapbs_ settlements_services', isPartner: false },
    { name: 'Arab Bank of Australia', shortName: 'ABAL', id: 'arab_bank_of_australia', isPartner: false },
    { name: 'ABN AMRO', shortName: 'ABN AMRO', id: 'abn_amro', isPartner: false },
    { name: 'Australia Central Credit Union', shortName: 'ACCU', id: 'australia_central_credit_union', isPartner: false },
    {
        name: 'Australian Defence Credit Union',
        shortName: 'ADCU',
        id: 'australian_defence_credit_union',
        isPartner: false,
    },
    { name: 'Advantedge', shortName: 'Advantedge', id: 'advantedge', isPartner: false },
    { name: 'AFG Home Loans', shortName: 'AFG', id: 'afg_home_loans', isPartner: false },
    { name: 'Australian First Mortgage', shortName: 'AFM', id: 'australian_first_mortgage', isPartner: false },
    { name: 'Australian Military Bank', shortName: 'AMB', id: 'australian_military_bank', isPartner: false },
    { name: 'Australian Mortgage Options', shortName: 'AMO', id: 'australian_mortgage_options', isPartner: false },
    { name: 'AGC', shortName: 'AGC', id: 'agc', isPartner: false },
    { name: 'AIMS Home Loans', shortName: 'AIMS', id: 'aims', isPartner: false },
    { name: 'Allianz', shortName: 'ALV', id: 'allianz', isPartner: false },
    { name: 'AMG', shortName: 'AMG', id: 'amg', isPartner: false },
    { name: 'AMIC', shortName: 'AMIC', id: 'amic', isPartner: false },
    { name: 'AMIST', shortName: 'AMIST', id: 'amist', isPartner: false },
    { name: 'AMS', shortName: 'AMS', id: 'ams', isPartner: false },
    { name: 'Aon Master Trust', shortName: 'AON', id: 'aon_master_trust', isPartner: false },
    { name: 'API', shortName: 'API', id: 'api', isPartner: false },
    { name: 'Athena Home Loans', shortName: 'Athena', id: 'athena_home_loans', isPartner: false },
    {
        name: 'Australian Unity Building Society',
        shortName: 'AUBS',
        id: 'australian_unity_building_society',
        isPartner: false,
    },
    { name: 'Aussie Activate', shortName: 'AUSPEPPER', id: 'aussie_activate', isPartner: false },
    { name: 'Aussie Elevate', shortName: 'AUSADE', id: 'aussie_elevate', isPartner: false },
    { name: 'Aussie Home Loans', shortName: 'Aussie', id: 'aussie_home_loans', isPartner: false },
    { name: 'Aussie Select', shortName: 'AUSCBA', id: 'aussie_select', isPartner: false },
    { name: 'AVCO', shortName: 'AVCO', id: 'avco', isPartner: false },
    { name: 'AWA Alliance Bank', shortName: 'AWA', id: 'awa_alliance_bank', isPartner: false },
    { name: 'AXA', shortName: 'AXA', id: 'axa', isPartner: false },
    { name: 'American Express', shortName: 'AMEX', id: 'american_express', isPartner: false },
    { name: 'Bank of America', shortName: 'BAC', id: 'bank_of_america', isPartner: false },
    { name: 'B&E', shortName: 'bande', id: 'bande', isPartner: false },
    { name: 'Bank mecu', shortName: 'bankmecu', id: 'bank_mecu', isPartner: false },
    { name: 'Bank of Sydney', shortName: 'banksyd', id: 'bank_of_sydney', isPartner: false },
    { name: 'Bank Vic', shortName: 'bankvic', id: 'bank_vic', isPartner: false },
    { name: 'Barclays', shortName: 'BARC', id: 'barclays', isPartner: false },
    { name: 'BCU', shortName: 'bcu', id: 'bcu', isPartner: false },
    { name: 'BDCU Alliance Bank', shortName: 'BDCUAB', id: 'bdcu_alliance_bank', isPartner: false },
    {
        name: 'Bass and Equitable Building Society',
        shortName: 'BEBS',
        id: 'bass_and_equitable_building_society',
        isPartner: false,
    },
    { name: 'Bendigo Bank', shortName: 'bendigo', id: 'bendigo_bank', isPartner: false },
    { name: 'Beyond Bank Australia', shortName: 'beyondbank', id: 'beyond_bank_australia', isPartner: false },
    {
        name: 'Broken Hill Community Credit Union',
        shortName: 'BHCCU',
        id: 'broken_hill_community_credit_union',
        isPartner: false,
    },
    { name: 'Bigsky Building Society', shortName: 'bigsky', id: 'bigsky_building_society', isPartner: false },
    { name: 'Better Mortgage Corporation', shortName: 'BMMC', id: 'better_mortgage_corporation', isPartner: false },
    { name: 'BMW Australia', shortName: 'BMW', id: 'bmw_australia', isPartner: false },
    { name: 'Banque Nationale De Paris', shortName: 'BNP', id: 'banque_nationale_de_paris', isPartner: false },
    { name: 'Bank of China', shortName: 'BOC', id: 'bank_of_china', isPartner: false },
    { name: 'Bank of Heritage Isle', shortName: 'BOCHI', id: 'bank_of_heritage_isle', isPartner: false },
    { name: 'Bank of Queensland', shortName: 'boq', id: 'bank_of_queensland', isPartner: false },
    { name: 'Bankers Trust Australia', shortName: 'BTA', id: 'bankers_trust_australia', isPartner: false },
    { name: 'BankVic', shortName: 'BV', id: 'bankvic', isPartner: false },
    { name: 'Mutual Community', shortName: 'Bupa', id: 'mutual_community', isPartner: false },
    { name: 'BUSSQ', shortName: 'BUSSQ', id: 'bussq', isPartner: false },
    { name: 'CBFC', shortName: 'CBFC', id: 'cbfc', isPartner: false },
    { name: 'CBUS', shortName: 'CBUS', id: 'cbus', isPartner: false },
    { name: 'Central West Credit Union', shortName: 'CWCU', id: 'central_west_credit_union', isPartner: false },
    { name: 'City Coast Credit Union', shortName: 'CCCU', id: 'city_coast_credit_union', isPartner: false },
    { name: 'Circle Credit Union', shortName: 'CCU', id: 'circle_credit_union', isPartner: false },
    { name: 'CGU', shortName: 'CGU', id: 'cgu', isPartner: false },
    { name: 'CHU', shortName: 'CHU', id: 'chu', isPartner: false },
    { name: 'CIC', shortName: 'CIC', id: 'cic', isPartner: false },
    { name: 'CIL', shortName: 'CIL', id: 'cil', isPartner: false },
    { name: 'Circle Alliance Bank', shortName: 'CAB', id: 'circle_alliance_bank', isPartner: false },
    { name: 'CIT Credit Pty', shortName: 'CIT', id: 'cit_credit_pty', isPartner: false },
    { name: 'Club Plus Super', shortName: 'CLB', id: 'clb_plus_super', isPartner: false },
    { name: 'Challenge Bank', shortName: 'CLG', id: 'challenge_bank', isPartner: false },
    {
        name: 'Community First Credit Union',
        shortName: 'communityfirst',
        id: 'comunity_first_credit_union',
        isPartner: false,
    },
    { name: 'Credit Union Australia', shortName: 'cua', id: 'credit_union_australia', isPartner: false },
    {
        name: 'Credit Union Financial Services',
        shortName: 'CUFS',
        id: 'credit_union_financial_services',
        isPartner: false,
    },
    { name: 'Coastline Credit Union', shortName: 'CUS', id: 'coastline_credit_union', isPartner: false },
    { name: 'Deutsche Bank', shortName: 'DBK', id: 'deutsche_bank', isPartner: false },
    { name: 'Diners Club', shortName: 'DCI', id: 'diners_club', isPartner: false },
    { name: 'Defence Bank', shortName: 'defencebank', id: 'defence_bank', isPartner: false },
    { name: 'ECU', shortName: 'ECU', id: 'ecu', isPartner: false },
    { name: 'EECU', shortName: 'EECU', id: 'eecu', isPartner: false },
    { name: 'Elders', shortName: 'EFP', id: 'elders', isPartner: false },
    { name: 'EISS', shortName: 'EISS', id: 'eiss', isPartner: false },
    { name: 'Fundcorp', shortName: 'FCI', id: 'fundcorp', isPartner: false },
    { name: 'Firefighters mutual bank', shortName: 'FMB', id: 'firefighters_mutual_bank', isPartner: false },
    { name: 'Genworth', shortName: 'Genworth', id: 'genworth', isPartner: false },
    { name: 'GIO', shortName: 'GIO', id: 'gio', isPartner: false },
    { name: 'Goldfields Money', shortName: 'goldfields_money', id: 'gmac_finance', isPartner: false },
    { name: 'Great Pacific Financial', shortName: 'GPF', id: 'great_pacific_financial', isPartner: false },
    { name: 'Great Southern Bank', shortName: 'GSB', id: 'great_southern_bank', isPartner: false },
    { name: 'GRE', shortName: 'GRE', id: 'gre', isPartner: false },
    { name: 'Guild', shortName: 'Guild', id: 'guild', isPartner: false },
    { name: 'HBF', shortName: 'HBF', id: 'hbf', isPartner: false },
    { name: 'HESTA', shortName: 'Hesta', id: 'hesta', isPartner: false },
    { name: 'Holiday Coast Credit Union', shortName: 'HCCU', id: 'holiday_coast_credit_union', isPartner: false },
    { name: 'Homeloans Ltd', shortName: 'HLLC', id: 'homeloans_ltd', isPartner: false },
    { name: 'HSBC', shortName: 'hsbc', id: 'hsbc', isPartner: false },
    { name: 'Hume Building Society', shortName: 'Hume', id: 'hume_building_society', isPartner: false },
    { name: 'International Acceptance', shortName: 'IA', id: 'international_acceptance', isPartner: false },
    {
        name: 'International Commercial Bank of China',
        shortName: 'ICBC',
        id: 'international_commercial_bank_of_china',
        isPartner: false,
    },
    { name: 'IDEG', shortName: 'IDEG', id: 'ideg', isPartner: false },
    { name: 'Illawarra Credit Union', shortName: 'illawarra', id: 'illawarra_credit_union', isPartner: false },
    { name: 'IMB Ltd', shortName: 'imb', id: 'imb_ltd', isPartner: false },
    { name: 'ING Direct', shortName: 'INGC', id: 'ing_direct', isPartner: false },
    { name: 'IOOF Building Society', shortName: 'IOOF', id: 'ioof_building_society', isPartner: false },
    { name: 'Keystart Home Loans', shortName: 'KST', id: 'keystart_home_loans', isPartner: false },
    { name: 'Kwik Kash International', shortName: 'Kwik Kash', id: 'kwik_kash_international', isPartner: false },
    { name: 'Local Government', shortName: 'LGS', id: 'local_government', isPartner: false },
    { name: 'Liberty', shortName: 'liberty', id: 'liberty', isPartner: false },
    { name: 'Lombard Finance', shortName: 'Lombard', id: 'lombard_finance', isPartner: false },
    { name: 'LUCRF Super', shortName: 'LUCRF', id: 'lucrf_super', isPartner: false },
    { name: 'Macquarie Credit Union', shortName: 'macquariecu', id: 'macquarie_credit_union', isPartner: false },
    { name: 'MAP', shortName: 'MAP', id: 'map', isPartner: false },
    { name: 'Mediplan Australia', shortName: 'Mediplan', id: 'mediplan_australia', isPartner: false },
    { name: 'Mercantile Mutual', shortName: 'MERC', id: 'mercantile_mutual', isPartner: false },
    { name: 'Mercer Wealth', shortName: 'Mercer', id: 'mercer_wealth', isPartner: false },
    { name: 'Midland Bank PLC', shortName: 'Midland', id: 'midland_bank_plc', isPartner: false },
    { name: 'Mine Wealth and Wellbeing', shortName: 'Mine Super', id: 'mine_wealth_and_wellbeing', isPartner: false },
    { name: 'MIP', shortName: 'MIP', id: 'mip', isPartner: false },
    { name: 'MIS', shortName: 'MIS', id: 'mis', isPartner: false },
    { name: 'MLC', shortName: 'MLC', id: 'mlc', isPartner: false },
    { name: 'MMI', shortName: 'MMI', id: 'mmi', isPartner: false },
    { name: 'MTAA', shortName: 'MTAA', id: 'mtaa', isPartner: false },
    { name: 'My Credit Union', shortName: 'mycredit', id: 'my_credit_union', isPartner: false },
    { name: 'NSF Super', shortName: 'Nationwide', id: 'nsf_super', isPartner: false },
    { name: 'Natwest Markets Australia', shortName: 'Natwest', id: 'natwest_markets_australia', isPartner: false },
    { name: 'Northern Building Society', shortName: 'NBS', id: 'northern_building_society', isPartner: false },
    { name: 'Northern Inland Credit Union', shortName: 'NICU', id: 'northern_inland_credit_union', isPartner: false },
    { name: 'NGS', shortName: 'NGS', id: 'ngs', isPartner: false },
    { name: 'National Mortgage Company', shortName: 'nmc', id: 'national_mortgage_company', isPartner: false },
    { name: 'NRMA', shortName: 'NRMA', id: 'nrma', isPartner: false },
    { name: 'NZI', shortName: 'NZI', id: 'nzi', isPartner: false },
    { name: 'OneTwo', shortName: 'OneTwo', id: 'one_two', isPartner: false },
    {
        name: 'Overseas-Chinese Banking Corporation',
        shortName: 'OCBC Bank',
        id: 'overseas_chinese_banking_corporation',
        isPartner: false,
    },
    { name: 'Origin Finance', shortName: 'Origin', id: 'origin_finance', isPartner: false },
    { name: 'Origin MMS', shortName: 'OriginMMS', id: 'origin_mms', isPartner: false },
    {
        name: 'Pioneer Permanent Building Society',
        shortName: 'PBS',
        id: 'pioneer_permanent_building_society',
        isPartner: false,
    },
    {
        name: "People's Choice Credit Union",
        shortName: 'peopleschoicecu',
        id: 'peoples_choice_credit_union',
        isPartner: false,
    },
    { name: 'Perpetual Limited', shortName: 'Perpetual', id: 'perpetual_limited', isPartner: false },
    { name: 'Plum', shortName: 'Plum', id: 'plum', isPartner: false },
    { name: 'Police Credit Union', shortName: 'policecu', id: 'police_credit_union', isPartner: false },
    { name: 'QANTAS Credit Union', shortName: 'qantas', id: 'qantas_credit_union', isPartner: false },
    { name: 'QBE', shortName: 'QBE', id: 'qbe', isPartner: false },
    {
        name: 'Queensland Country Credit Union',
        shortName: 'QCCU',
        id: 'queensland_country_credit_union',
        isPartner: false,
    },
    { name: 'RAC', shortName: 'RAC', id: 'rac', isPartner: false },
    { name: 'RACV', shortName: 'RACV', id: 'racv', isPartner: false },
    { name: 'RAMS', shortName: 'rams', id: 'rams', isPartner: false },
    { name: 'Reserve Bank of Australia', shortName: 'RBA', id: 'reserve_bank_of_australia', isPartner: false },
    { name: 'REA Home Loans', shortName: 'REA', id: 'rea_home_loans', isPartner: false },
    { name: 'Safrock Finance', shortName: 'Safrock', id: 'safrock_finance', isPartner: false },
    { name: 'Suncorp Metway', shortName: 'SCMC', id: 'suncorp_metway', isPartner: false },
    { name: 'SGIC', shortName: 'SGIC', id: 'sgic', isPartner: false },
    { name: 'SGIO', shortName: 'SGIO', id: 'sgio', isPartner: false },
    {
        name: 'State Street Bank And Trust Company',
        shortName: 'state street',
        id: 'state_street_bank_and_trust_company',
        isPartner: false,
    },
    { name: 'Summerland Credit Union', shortName: 'Summerland', id: 'summerland_credit_union', isPartner: false },
    { name: 'Macarthur Credit Union', shortName: 'The MAC', id: 'macarthur_credit_union', isPartner: false },
    {
        name: 'Maitland Mutual Building Society',
        shortName: 'The Mutual',
        id: 'maitland_mutual_building_society',
        isPartner: false,
    },
    {
        name: 'Thinktank lending commercial finance',
        shortName: 'Thinktank',
        id: 'thinktank_lending_commercial_finance',
        isPartner: false,
    },
    { name: 'Tictoc Online', shortName: 'Tictoc', id: 'tictoc_online', isPartner: false },
    { name: 'Tic:Toc Home Loans', shortName: 'Tictoc', id: 'tictoc_home_loans', isPartner: false },
    { name: 'Trust Bank of Tasmania', shortName: 'Trust Bank', id: 'trust_bank_of_tasmania', isPartner: false },
    { name: 'Unibank', shortName: 'Uni', id: 'unibank', isPartner: false },
    { name: 'United Overseas Bank', shortName: 'UOB', id: 'united_overseas_bank', isPartner: false },
    {
        name: 'Victoria Teachers Credit Union Ltd',
        shortName: 'victeach',
        id: 'victeach_teachers_credit_union_ltd',
        isPartner: false,
    },
    { name: 'Credit Corp', shortName: 'CCFS', id: 'credit_corp', isPartner: false },
    { name: 'Credit Union SA', shortName: 'CUSA', id: 'credit_union_sa', isPartner: false },
    { name: 'Family First Credit Union', shortName: 'FFCU', id: 'family_first_credit_union', isPartner: false },
    { name: 'Fox Symes', shortName: 'FS', id: 'fox_symes', isPartner: false },
    { name: 'Freedom Lend', shortName: 'FL', id: 'freedom_lend', isPartner: false },
    { name: 'Lysaght Credit Union', shortName: 'LCU', id: 'lysaght_credit_union', isPartner: false },
    { name: 'Police Credit Union (NSW)', shortName: 'policecu', id: 'police_credit_union_nsw', isPartner: false },
    { name: 'The Rock', shortName: 'RBS', id: 'the_rock', isPartner: false },
    { name: 'Zip Co', shortName: 'Zip', id: 'zip', isPartner: false },
    { name: 'Plenti', shortName: 'Plenti', id: 'plenti', isPartner: false },
    { name: 'Latitude Financial', shortName: 'Latitude', id: 'latitude', isPartner: false },
    { name: 'Cash Converters', shortName: 'Cash Converters', id: 'cash_converters', isPartner: false },
    { name: 'Nimble', shortName: 'Nimble', id: 'nimble', isPartner: false },
    { name: 'SocietyOne', shortName: 'SocietyOne', id: 'societyone', isPartner: false },
    { name: 'MoneyMe', shortName: 'mme', id: 'moneyme', isPartner: false },
    { name: 'Harmoney', shortName: 'Harmoney', id: 'harmoney', isPartner: false },
    { name: 'Afterpay', shortName: 'Afterpay', id: 'afterpay', isPartner: false },
    {
        name: 'Australian Pensioners Insurance',
        shortName: 'API',
        id: 'australian_pensioners_insurance',
        isPartner: false,
    },
    { name: 'Cash Converters ', shortName: 'Cash Converters', id: 'cash_converters_', isPartner: false },
    { name: 'Iden Group', shortName: 'Iden', id: 'iden_group', isPartner: false },
    { name: 'Members Equity Bank', shortName: 'ME Bank', id: 'members_equity_bank', isPartner: false },
    { name: 'National Mortgage Corporation', shortName: 'NMC', id: 'national_mortgage_corporation', isPartner: false },
    { name: 'Queensland Credit Union', shortName: 'QCU', id: 'queensland_credit_union', isPartner: false },
    {
        name: 'Queensland Professional Credit Union',
        shortName: 'QPCU',
        id: 'queensland_professional_credit_union',
        isPartner: false,
    },
    { name: 'Think Tank Group Pty Ltd', shortName: 'Think Tank', id: 'think_tank_group_pty_ltd', isPartner: false },
    {
        name: 'Volkswagon Financial Services',
        shortName: 'VW Finance',
        id: 'volkswagon_financial_services',
        isPartner: false,
    },
    { name: 'Zip Co', shortName: 'zip', id: 'zip_co', isPartner: false },
];
export var NON_PARTNER_WITHOUT_SHORTNAME = [
    { name: 'CommBank Financial Planner', shortName: '', id: 'commBank_financial_planner', isPartner: false },
    { name: 'Homeloans.com.au', shortName: '', id: 'homeloans_com_au', isPartner: false },
    { name: 'Horizon Bank', shortName: '', id: 'horizon_bank', isPartner: false },
    { name: 'Loans.com.au', shortName: '', id: 'loans_com_au', isPartner: false },
    { name: 'Nova Alliance Bank', shortName: '', id: 'nova_alliance_bank', isPartner: false },
    { name: 'QBank', shortName: '', id: 'qbank', isPartner: false },
    { name: 'Reduce', shortName: '', id: 'reduce', isPartner: false },
    { name: 'Regional Australia Bank', shortName: '', id: 'regional_australia_bank', isPartner: false },
    { name: 'Unity Bank', shortName: '', id: 'unity_bank', isPartner: false },
    { name: 'Allstate Home Loans', shortName: '', id: 'allstate_home_loans', isPartner: false },
    { name: 'ANZ Wealth', shortName: '', id: 'anz_wealth', isPartner: false },
    { name: 'Armidale Building Society', shortName: '', id: 'armidale_building_society', isPartner: false },
    { name: 'Asahi Bank', shortName: '', id: 'asahi_bank', isPartner: false },
    { name: 'Assured', shortName: '', id: 'assured', isPartner: false },
    { name: 'Athena', shortName: '', id: 'athena', isPartner: false },
    { name: 'Aussie Mastercard', shortName: '', id: 'aussie_mastercard', isPartner: false },
    { name: 'Aussie Mortgage Ltd', shortName: '', id: 'aussie_mortgage', isPartner: false },
    { name: 'Aust Alliance', shortName: '', id: 'aust_alliance', isPartner: false },
    { name: 'Austral Mortgage', shortName: '', id: 'austral_mortgage', isPartner: false },
    { name: 'Australian Ethical', shortName: '', id: 'australian _ethical', isPartner: false },
    { name: 'AustralianSuper', shortName: '', id: 'australian_super', isPartner: false },
    { name: 'AustSafe', shortName: '', id: 'aust_safe', isPartner: false },
    { name: 'Australian Catholic', shortName: '', id: 'australian_catholic', isPartner: false },
    { name: 'Australian Eagle', shortName: '', id: 'australian_eagle', isPartner: false },
    { name: 'AV Super', shortName: '', id: 'av_super', isPartner: false },
    { name: 'Bank of Tokyo-Mitsubishi', shortName: '', id: 'bank_of_tokyo_mitsubishi', isPartner: false },
    { name: 'Barnes Home Loans', shortName: '', id: 'barnes_home_loans', isPartner: false },
    { name: 'Brighten Home Loans', shortName: '', id: 'brighten_ome_loans', isPartner: false },
    { name: 'Building Society MP', shortName: '', id: 'building_society_mp', isPartner: false },
    { name: 'Buyers Edge', shortName: '', id: 'buyers_edge', isPartner: false },
    { name: 'Capital Finance', shortName: '', id: 'capital_finance', isPartner: false },
    { name: 'Capricornia Credit Union', shortName: '', id: 'capricornia_credit_union', isPartner: false },
    { name: 'CareSuper', shortName: '', id: 'care_super', isPartner: false },
    { name: 'Cash Doctors', shortName: '', id: 'cash_doctors', isPartner: false },
    { name: 'Catalyst Money', shortName: '', id: 'catalyst_money', isPartner: false },
    { name: 'Catholic Church', shortName: '', id: 'catholic_church', isPartner: false },
    { name: 'Catholic Super', shortName: '', id: 'catholic_super', isPartner: false },
    { name: 'Certegy', shortName: '', id: 'certegy', isPartner: false },
    { name: 'Chase Manhattan Bank', shortName: '', id: 'chase_manhattan_bank', isPartner: false },
    { name: 'Chequecash Pty Ltd', shortName: '', id: 'chequecash_pty_ltd', isPartner: false },
    { name: 'ChoiceLend', shortName: '', id: 'choiceLend', isPartner: false },
    { name: 'Christian Super', shortName: '', id: 'christian_super', isPartner: false },
    { name: 'Citywide Home Loans', shortName: '', id: 'citywide_home_loans', isPartner: false },
    { name: 'Co Operative Ins Co', shortName: '', id: 'co_operative_ins_co', isPartner: false },
    { name: 'Colonial First State', shortName: '', id: 'colonial_first_state', isPartner: false },
    { name: 'Colonial Mutual', shortName: '', id: 'colonial_mutual', isPartner: false },
    { name: 'Colonial', shortName: '', id: 'colonial', isPartner: false },
    { name: 'Commercial Union', shortName: '', id: 'commercial_union', isPartner: false },
    { name: 'CommInsure', shortName: '', id: 'commInsure', isPartner: false },
    { name: 'CPS Credit Union', shortName: '', id: 'cps_ credit Union', isPartner: false },
    { name: 'Credit Union Settlement Services', shortName: '', id: 'credit_union_settlement_services', isPartner: false },
    { name: 'Cumis', shortName: '', id: 'cumis', isPartner: false },
    { name: 'Cuscal', shortName: '', id: 'Cuscal', isPartner: false },
    { name: 'Custom Credit', shortName: '', id: 'custom_credit', isPartner: false },
    { name: 'Dai-Ichi Kango Bank', shortName: '', id: 'dai_ichi_kango_bank', isPartner: false },
    { name: 'Daimlerchrysler Finance', shortName: '', id: 'daimlerchrysler_finance', isPartner: false },
    { name: 'Debt Purchase Australia', shortName: '', id: 'debt_purchase_australia', isPartner: false },
    { name: 'Defence Credit', shortName: '', id: 'defence_credit', isPartner: false },
    {
        name: 'Defence Force Credit Union Limited',
        shortName: '',
        id: 'defence_force_credit_union_limited',
        isPartner: false,
    },
    { name: 'Defence Services Homes', shortName: '', id: 'defence_services_homes', isPartner: false },
    { name: 'Delphi Bank', shortName: '', id: 'delphi_bank', isPartner: false },
    {
        name: 'Dnister Ukrainian Credit Co-operative',
        shortName: '',
        id: 'dnister_ukrainian_credit_co_operative',
        isPartner: false,
    },
    { name: 'Easy Street Financial Services', shortName: '', id: 'easy_street_financial_services', isPartner: false },
    { name: 'ELCOM Credit Union', shortName: '', id: 'elcom_credit_union', isPartner: false },
    { name: 'Energy Super', shortName: '', id: 'energy_super', isPartner: false },
    { name: 'Equity Super', shortName: '', id: 'equity_super', isPartner: false },
    { name: 'Esanda', shortName: '', id: 'esanda', isPartner: false },
    { name: 'Essential Super', shortName: '', id: 'essential_super', isPartner: false },
    { name: 'Ezy Bank', shortName: '', id: 'ezy_bank', isPartner: false },
    { name: 'FAI', shortName: '', id: 'fai', isPartner: false },
    { name: 'FASTLend', shortName: '', id: 'fastlend', isPartner: false },
    { name: 'Federation', shortName: '', id: 'federation', isPartner: false },
    { name: 'FinancePath', shortName: '', id: 'finance_path', isPartner: false },
    { name: 'Fire Brigades Credit Union', shortName: '', id: 'fire_brigades_credit_union', isPartner: false },
    { name: 'Fire Service Credit Union', shortName: '', id: 'fire_service_credit_union', isPartner: false },
    { name: 'First Choice Credit Union', shortName: '', id: 'first_choice_credit_union', isPartner: false },
    { name: 'First National Bank of Chicago', shortName: '', id: 'first_national_bank_of_chicago', isPartner: false },
    { name: 'First Option Bank', shortName: '', id: 'first_option_bank', isPartner: false },
    { name: 'First Permanent Home Loans', shortName: '', id: 'first_permanent_home_loans', isPartner: false },
    {
        name: 'First Provincial Building Society',
        shortName: '',
        id: 'first_provincial_building_society',
        isPartner: false,
    },
    { name: 'First State Super', shortName: '', id: 'first_state_super', isPartner: false },
    { name: 'First Super', shortName: '', id: 'first_super', isPartner: false },
    { name: 'Flexirent', shortName: '', id: 'flexirent', isPartner: false },
    { name: 'Ford Credit', shortName: '', id: 'ford_credit', isPartner: false },
    { name: 'Fortis', shortName: '', id: 'fortis', isPartner: false },
    { name: 'Future Financial', shortName: '', id: 'future_financial', isPartner: false },
    { name: 'G&C Mutual Bank', shortName: '', id: 'gc_mutual_bank', isPartner: false },
    { name: 'GE Automotive', shortName: '', id: 'ge_automotive', isPartner: false },
    {
        name: 'GE Capital Finance (Go Mastercard)',
        shortName: '',
        id: 'ge_capital_finance_go_mastercard',
        isPartner: false,
    },
    { name: 'GE Capital Finance', shortName: '', id: 'ge_capital_finance', isPartner: false },
    { name: 'GE Credit Line', shortName: '', id: 'ge_credit_line', isPartner: false },
    { name: 'Ge Finance', shortName: '', id: 'ge_finance', isPartner: false },
    { name: 'GE Money Aust Pty Ltd', shortName: '', id: 'ge_money_aust_pty_ltd', isPartner: false },
    { name: 'GE Mortgages', shortName: '', id: 'ge_mortgages', isPartner: false },
    { name: 'Geelong Bank', shortName: '', id: 'geelong_bank', isPartner: false },
    { name: 'GIO Building Society', shortName: '', id: 'gio_building_society', isPartner: false },
    { name: 'Grace Bros', shortName: '', id: 'grace_bros', isPartner: false },
    { name: 'Greater Building Society', shortName: '', id: 'greater_building_society', isPartner: false },
    { name: 'Hanover Consumer Finance', shortName: '', id: 'hanover_consumer_finance', isPartner: false },
    { name: 'Home Building Society', shortName: '', id: 'home_building_society', isPartner: false },
    { name: 'Homeside', shortName: '', id: 'homeside', isPartner: false },
    { name: 'Homestar Finance', shortName: '', id: 'homestar_finance', isPartner: false },
    { name: 'Homestart Finance', shortName: 'HST', id: 'homestart_finance', isPartner: false },
    { name: 'Homeswest', shortName: '', id: 'homeswest', isPartner: false },
    { name: 'Hunter United', shortName: '', id: 'hunter_united', isPartner: false },
    { name: 'IBJ Australia Bank', shortName: '', id: 'ibj_australia_bank', isPartner: false },
    { name: 'Ignite', shortName: '', id: 'ignite', isPartner: false },
    { name: 'Illawarra Building Society', shortName: '', id: 'illawarra_building_society', isPartner: false },
    { name: 'INC Invest', shortName: '', id: 'inc_invest', isPartner: false },
    { name: 'ING Mercantile Mutual Bank', shortName: '', id: 'ing_mercantile_mutual_bank', isPartner: false },
    { name: 'Intech Credit Union', shortName: '', id: 'intech_credit_union', isPartner: false },
    { name: 'InTrust', shortName: '', id: 'in_trust', isPartner: false },
    { name: 'Investec', shortName: '', id: 'investec', isPartner: false },
    { name: 'Kinetic', shortName: '', id: 'kinetic', isPartner: false },
    { name: 'Legal Super', shortName: '', id: 'legal_super', isPartner: false },
    { name: 'Lion Finance', shortName: '', id: 'lion_finance', isPartner: false },
    { name: 'M Capitol', shortName: '', id: 'm_capitol', isPartner: false },
    {
        name: 'Mackay Permanent Building Society',
        shortName: '',
        id: 'mackay_permanent_building_society',
        isPartner: false,
    },
    { name: 'Manufacture Mutual', shortName: '', id: 'manufacture_mutual', isPartner: false },
    { name: 'Media Super', shortName: '', id: 'media_super', isPartner: false },
    { name: 'Mitchell Building Society', shortName: '', id: 'mitchell_building_society', isPartner: false },
    {
        name: 'Morgan Guaranty Trust Bank of New York',
        shortName: '',
        id: 'morgan_guaranty_trust_bank_of_new_york',
        isPartner: false,
    },
    { name: 'Mortgage Choice', shortName: '', id: 'mortgage_choice', isPartner: false },
    { name: 'Mortgage Ezy', shortName: '', id: 'mortgage_ezy', isPartner: false },
    { name: 'Mortgage House', shortName: '', id: 'mortgage_house', isPartner: false },
    { name: 'Mortgage Mart', shortName: '', id: 'mortgage_mart', isPartner: false },
    { name: 'Mortgageport', shortName: '', id: 'mortgageport', isPartner: false },
    { name: 'MOVE Bank', shortName: '', id: 'move_bank', isPartner: false },
    { name: 'NCUIS', shortName: '', id: 'ncuis', isPartner: false },
    { name: 'NSW Home Loans', shortName: '', id: 'new_home_loans', isPartner: false },
    { name: 'NSW Teachers Credit Union', shortName: '', id: 'new__teachers_credit_union', isPartner: false },
    { name: 'OneAnswer', shortName: '', id: 'one_answer', isPartner: false },
    { name: 'Orange Credit Union', shortName: '', id: 'orange_credit_union', isPartner: false },
    { name: 'Other', shortName: '', id: 'other', isPartner: false },
    { name: 'Payday Central', shortName: '', id: 'payday_central', isPartner: false },
    { name: 'Pensioners Insurance', shortName: '', id: 'pensioners_insurance', isPartner: false },
    { name: 'Perpetual Trustee', shortName: '', id: 'perpetual_trustee', isPartner: false },
    { name: 'PLANLend', shortName: '', id: 'planlend', isPartner: false },
    { name: 'Police and Nurses', shortName: '', id: 'police_and_nurses', isPartner: false },
    { name: 'Police Bank', shortName: '', id: 'police_bank', isPartner: false },
    { name: 'Powerstate Credit Union', shortName: '', id: 'powerstate_credit_union', isPartner: false },
    {
        name: 'Primary Industry Bank of Australia',
        shortName: '',
        id: 'primary_industry_bank_of_australia',
        isPartner: false,
    },
    { name: 'Prime', shortName: '', id: 'prime', isPartner: false },
    { name: 'Prospect Credit Union', shortName: '', id: 'prospect_credit_union', isPartner: false },
    { name: 'Public Trustee', shortName: '', id: 'public_trustee', isPartner: false },
    { name: 'Pulse Credit Union', shortName: '', id: 'pulse_credit_union', isPartner: false },
    { name: 'Qudos Bank', shortName: '', id: 'qudos_bank', isPartner: false },
    {
        name: 'Queensland Industry Development Corp',
        shortName: '',
        id: 'queensland_industry_development_corp',
        isPartner: false,
    },
    { name: 'Queensland Teachers Credit Union', shortName: '', id: 'queensland_teachers_credit_union', isPartner: false },
    { name: 'Queenslanders Credit Union', shortName: '', id: 'queenslanders_credit_union', isPartner: false },
    { name: 'REST Super', shortName: '', id: 'rest_super', isPartner: false },
    { name: 'RAC WA', shortName: '', id: 'rac_wa', isPartner: false },
    { name: 'RACQ Bank', shortName: '', id: 'racq_bank', isPartner: false },
    { name: 'Radio Rentals', shortName: '', id: 'radio_rentals', isPartner: false },
    { name: 'Railways Credit Union', shortName: '', id: 'railways_credit_union', isPartner: false },
    { name: 'Repcol', shortName: '', id: 'repcol', isPartner: false },
    { name: 'RESI Mortgage Corporation', shortName: '', id: 'resi_mortgage_corporation,', isPartner: false },
    { name: 'Resi', shortName: '', id: 'resi,', isPartner: false },
    { name: 'Royal Life', shortName: '', id: 'royal_life,', isPartner: false },
    { name: 'Russell Investments', shortName: '', id: 'russell_investments', isPartner: false },
    { name: 'Sanwa Australia Finance Limited', shortName: '', id: 'Sanwa Australia Finance Limited', isPartner: false },
    { name: 'Savings And Loans Credit Union', shortName: '', id: 'savings_and_loans_credit_union', isPartner: false },
    { name: 'SCU', shortName: '', id: 'scu', isPartner: false },
    { name: 'Service One Alliance Bank', shortName: '', id: 'service_one_alliance_bank', isPartner: false },
    { name: 'Shannons', shortName: '', id: 'shannons', isPartner: false },
    { name: 'SmartSave', shortName: '', id: 'smart_save', isPartner: false },
    { name: 'Southern Cross Credit Union', shortName: '', id: 'southern_cross_credit_union', isPartner: false },
    { name: 'Sovereign Credit', shortName: '', id: 'sovereign_credit', isPartner: false },
    { name: 'St Andrew', shortName: '', id: 'st_andrew', isPartner: false },
    { name: 'Standard Chartered Bank Aust', shortName: '', id: 'standard_chartered_bank_aust', isPartner: false },
    { name: 'State Custodians', shortName: '', id: 'state_custodians', isPartner: false },
    { name: 'Statewide', shortName: '', id: 'statewide', isPartner: false },
    { name: 'Stronghold', shortName: '', id: 'stronghold', isPartner: false },
    { name: 'Sun Alliance', shortName: '', id: 'sun_alliance', isPartner: false },
    { name: 'Sunsuper', shortName: '', id: 'sunsuper', isPartner: false },
    { name: 'Swann', shortName: '', id: 'swann', isPartner: false },
    { name: 'TasPlan', shortName: '', id: 'tas_plan', isPartner: false },
    { name: 'Teachers Credit Union', shortName: '', id: 'teachers_credit_union', isPartner: false },
    {
        name: 'Territory Mutual Building Society',
        shortName: '',
        id: 'territory_mutual_building_society',
        isPartner: false,
    },
    { name: 'The Capricornia', shortName: '', id: 'the_capricornia', isPartner: false },
    { name: 'The Mac', shortName: '', id: 'the_mac', isPartner: false },
    { name: 'The Mutual Bank', shortName: '', id: 'the_mutual_bank', isPartner: false },
    { name: 'Tonto Home Loans', shortName: '', id: 'tonto_home_loans', isPartner: false },
    { name: 'Town And Country Bank', shortName: '', id: 'town_and_country_bank', isPartner: false },
    { name: 'Toyota Finance Australia', shortName: '', id: 'toyota_finance_australia', isPartner: false },
    { name: 'Transport Mutual Credit Union', shortName: '', id: 'transport_mutual_credit_union', isPartner: false },
    { name: 'TWUSUPER', shortName: '', id: 'twusuper', isPartner: false },
    { name: 'UBank', shortName: '', id: 'ubank', isPartner: false },
    { name: 'United Credit Union', shortName: '', id: 'united_credit_union', isPartner: false },
    { name: 'University Credit Society', shortName: '', id: 'university_credit_society', isPartner: false },
    { name: 'VACC', shortName: '', id: 'vacc', isPartner: false },
    { name: 'Vero', shortName: '', id: 'vero', isPartner: false },
    { name: 'VicSuper', shortName: '', id: 'vic_super', isPartner: false },
    { name: 'Virgin Super', shortName: '', id: 'virgin_super', isPartner: false },
    { name: 'Visions', shortName: '', id: 'visions', isPartner: false },
    { name: 'Western QBE', shortName: '', id: 'western_qbe', isPartner: false },
    { name: 'Westfarmers', shortName: '', id: 'westfarmers', isPartner: false },
    { name: 'Westpack Insurance Services', shortName: '', id: 'westpack_insurance_services', isPartner: false },
    {
        name: 'Wide Bay Capricorn Building Society',
        shortName: '',
        id: 'wide_bay_capricorn_building_society',
        isPartner: false,
    },
    { name: 'Wizard', shortName: '', id: 'wizard', isPartner: false },
    {
        name: 'Woolworths Employees Credit Union',
        shortName: '',
        id: 'woolworths_employees_credit_union',
        isPartner: false,
    },
    { name: 'ANZ Asset Finance', shortName: '', id: 'anz_asset_finance', isPartner: false },
    { name: 'Nab Broker', shortName: '', id: 'nab_broker', isPartner: false },
    { name: 'PNC Financial services', shortName: '', id: 'pnc_financial_services', isPartner: false },
    { name: 'World Marine and General', shortName: '', id: 'world_marine_and_general', isPartner: false },
    { name: 'Xinja', shortName: '', id: 'xinjia', isPartner: false },
    { name: 'Yellow Brick Road', shortName: '', id: 'yellow_brick_road', isPartner: false },
    { name: 'Zurich', shortName: '', id: 'zurich', isPartner: false },
    { name: 'Volt', shortName: '', id: 'volt', isPartner: false },
    { name: 'BNK', shortName: '', id: 'BNK', isPartner: false },
    { name: '86 400', shortName: '', id: '86_400', isPartner: false },
    { name: 'ADCU', shortName: '', id: 'adcu', isPartner: false },
    { name: 'AFG Advantedge', shortName: '', id: 'afg_advantedge', isPartner: false },
    { name: 'AFM', shortName: '', id: 'afm', isPartner: false },
    { name: 'Ample Capital Australia', shortName: '', id: 'ample_capital_australia', isPartner: false },
    { name: 'Anchorage', shortName: '', id: 'anchorage', isPartner: false },
    { name: 'ANZ Asset Finance ', shortName: '', id: 'anz_asset_finance_', isPartner: false },
    { name: 'AUL', shortName: '', id: 'aul', isPartner: false },
    {
        name: 'Australian Financial Holdings Pty Ltd',
        shortName: '',
        id: 'australian_financial_holdings_pty_ltd',
        isPartner: false,
    },
    { name: 'Australian Lending Services', shortName: '', id: 'australian_lending_services', isPartner: false },
    { name: 'Australian Wholesale Lending', shortName: '', id: 'australian_wholesale_lending', isPartner: false },
    { name: 'Bank of South Australia', shortName: '', id: 'bank_of_south_australia', isPartner: false },
    { name: 'Banksia', shortName: '', id: 'banksia', isPartner: false },
    { name: 'BCHL', shortName: '', id: 'bchl', isPartner: false },
    { name: 'Bluegum', shortName: '', id: 'bluegum', isPartner: false },
    { name: 'BMC', shortName: '', id: 'bmc', isPartner: false },
    { name: 'BMC Advantedge', shortName: '', id: 'bmc_advantedge', isPartner: false },
    { name: 'CACU', shortName: '', id: 'cacu', isPartner: false },
    { name: 'Coles Financial Services', shortName: '', id: 'coles_financial_services', isPartner: false },
    { name: 'Collins Securities', shortName: '', id: 'collins_securities', isPartner: false },
    { name: 'Columbus Capital Pty Ltd', shortName: '', id: 'columbus_capital_pty_ltd', isPartner: false },
    { name: 'Community CPS Australia ', shortName: '', id: 'community_cps_australia_', isPartner: false },
    { name: 'Community Mutual Ltd', shortName: '', id: 'community_mutual_ltd', isPartner: false },
    { name: 'Credit Union Home Loans', shortName: '', id: 'credit_union_home_loans', isPartner: false },
    { name: 'Direct Mortgage Solutions', shortName: '', id: 'direct_mortgage_solutions', isPartner: false },
    { name: 'Director of Housing VIC ', shortName: '', id: 'director_of_housing_vic_', isPartner: false },
    { name: 'Domain', shortName: '', id: 'domain', isPartner: false },
    { name: 'Economy', shortName: '', id: 'economy', isPartner: false },
    { name: 'eMoney', shortName: '', id: 'emoney', isPartner: false },
    { name: 'Ezy Mortgage', shortName: '', id: 'ezy_mortgage', isPartner: false },
    { name: 'Faraday West and Co Pty Ltd', shortName: '', id: 'faraday_west_and_co_pty_ltd', isPartner: false },
    { name: 'Fifty Group', shortName: '', id: 'fifty_group', isPartner: false },
    { name: 'Finance Express Home Loans', shortName: '', id: 'finance_express_home_loans', isPartner: false },
    { name: 'First Folio', shortName: '', id: 'first_folio', isPartner: false },
    { name: 'Firstmac', shortName: '', id: 'firstmac', isPartner: false },
    { name: 'Fleet Partners Auto Loan', shortName: '', id: 'fleet_partners_auto_loan', isPartner: false },
    { name: 'FlexiGroup', shortName: '', id: 'flexigroup', isPartner: false },
    { name: 'Good Shepherd Microfinance', shortName: '', id: 'good_shepherd_microfinance', isPartner: false },
    { name: 'Great Southern Loans', shortName: '', id: 'great_southern_loans', isPartner: false },
    { name: 'Greater Bank Ltd', shortName: '', id: 'greater_bank_ltd', isPartner: false },
    { name: 'Harmoney Australia', shortName: '', id: 'harmoney_australia', isPartner: false },
    { name: 'HBS', shortName: '', id: 'hbs', isPartner: false },
    { name: 'Hemisphere', shortName: '', id: 'hemisphere', isPartner: false },
    { name: 'Homeloan Centre Australia', shortName: '', id: 'homeloan_centre_australia', isPartner: false },
    { name: 'HomePath', shortName: '', id: 'homepath', isPartner: false },
    { name: 'HostPlus', shortName: '', id: 'hostplus', isPartner: false },
    { name: 'Humm', shortName: '', id: 'humm', isPartner: false },
    { name: 'Infiniti Finservices Australia', shortName: '', id: 'infiniti_finservices_australia', isPartner: false },
    { name: 'JetStar Credit Cards', shortName: '', id: 'jetstar_credit_cards', isPartner: false },
    { name: 'Latitude Finance Australia', shortName: '', id: 'latitude_finance_australia', isPartner: false },
    { name: 'LoanMarket Advantedge', shortName: '', id: 'loanmarket_advantedge', isPartner: false },
    { name: 'LoanPlan', shortName: '', id: 'loanplan', isPartner: false },
    { name: 'Maxxia', shortName: '', id: 'maxxia', isPartner: false },
    { name: 'MCCA', shortName: '', id: 'mcca', isPartner: false },
    { name: 'Mercedez-Benz Financial Services', shortName: '', id: 'mercedez-benz_financial_services', isPartner: false },
    { name: 'MIIP', shortName: '', id: 'miip', isPartner: false },
    { name: 'Mitsubishi', shortName: '', id: 'mitsubishi', isPartner: false },
    { name: 'Money Quest Australia Pty Ltd', shortName: '', id: 'money_quest_australia_pty_ltd', isPartner: false },
    { name: 'MoneyPlace AFSL', shortName: '', id: 'moneyplace_afsl', isPartner: false },
    { name: 'MSL', shortName: '', id: 'msl', isPartner: false },
    { name: 'Myer Credit Cards', shortName: '', id: 'myer_credit_cards', isPartner: false },
    { name: 'MyOzMoney', shortName: '', id: 'myozmoney', isPartner: false },
    { name: 'Napiers', shortName: '', id: 'napiers', isPartner: false },
    { name: 'NCF Financial Services PtyLtd', shortName: '', id: 'ncf_financial_services_ptyltd', isPartner: false },
    { name: 'NFC', shortName: '', id: 'nfc', isPartner: false },
    { name: 'NHL', shortName: '', id: 'nhl', isPartner: false },
    { name: 'Nissan Financial Services', shortName: '', id: 'nissan_financial_services', isPartner: false },
    { name: 'NMMC', shortName: '', id: 'nmmc', isPartner: false },
    { name: 'Now Finance', shortName: '', id: 'now_finance', isPartner: false },
    { name: 'OFG', shortName: '', id: 'ofg', isPartner: false },
    { name: 'ORIX', shortName: '', id: 'orix', isPartner: false },
    { name: 'Paladin', shortName: '', id: 'paladin', isPartner: false },
    { name: 'Pioneer Credit Ltd', shortName: '', id: 'pioneer_credit_ltd', isPartner: false },
    { name: 'PNCS', shortName: '', id: 'pncs', isPartner: false },
    { name: 'Power Home Loans', shortName: '', id: 'power_home_loans', isPartner: false },
    { name: 'Rate Money Pty Ltd', shortName: '', id: 'rate_money_pty_ltd', isPartner: false },
    { name: 'RedZed', shortName: '', id: 'redzed', isPartner: false },
    { name: 'Renault Finance ', shortName: '', id: 'renault_finance_', isPartner: false },
    { name: 'Residential Mortgage Group', shortName: '', id: 'residential_mortgage_group', isPartner: false },
    { name: 'RHG', shortName: '', id: 'rhg', isPartner: false },
    { name: 'Sam Loans', shortName: '', id: 'sam_loans', isPartner: false },
    { name: 'Sandhurst Trustees', shortName: '', id: 'sandhurst_trustees', isPartner: false },
    { name: 'SGE Credit Union', shortName: '', id: 'sge_credit_union', isPartner: false },
    { name: 'Skyline Car Finance', shortName: '', id: 'skyline_car_finance', isPartner: false },
    { name: 'Smartline', shortName: '', id: 'smartline', isPartner: false },
    { name: 'Society One Australia', shortName: '', id: 'society_one_australia', isPartner: false },
    { name: 'Southland Building Society', shortName: '', id: 'southland_building_society', isPartner: false },
    { name: 'Sydney Home Loans', shortName: '', id: 'sydney_home_loans', isPartner: false },
    { name: 'Symple Loans Australia', shortName: '', id: 'symple_loans_australia', isPartner: false },
    { name: 'The Co-operative Bank', shortName: '', id: 'the_co-operative_bank', isPartner: false },
    { name: 'ThinkMe Finance', shortName: '', id: 'thinkme_finance', isPartner: false },
    { name: 'VTMB', shortName: '', id: 'vtmb', isPartner: false },
    { name: 'Wisr Finance Pty Ltd', shortName: '', id: 'wisr_finance_pty_ltd', isPartner: false },
    { name: 'Woolworths', shortName: '', id: 'woolworths', isPartner: false },
    { name: 'World Home Loans', shortName: '', id: 'world_home_loans', isPartner: false },
    { name: 'Yes Home Loans', shortName: '', id: 'yes_home_loans', isPartner: false },
    { name: 'Your Manager', shortName: '', id: 'your_manager', isPartner: false },
];
export var NON_PARTNER_LENDERS = __spreadArray(__spreadArray([], NON_PARTNER_WITH_SHORTNAME, true), NON_PARTNER_WITHOUT_SHORTNAME, true);
export var LENDERS = __spreadArray(__spreadArray([], PARTNER_LENDERS, true), NON_PARTNER_LENDERS, true);
export var LENDER_DICTIONARY = Object.fromEntries(__spreadArray(__spreadArray([], PARTNER_LENDERS_WITH_SHORTNAME.map(function (pl) { return [pl.name, pl]; }), true), NON_PARTNER_WITH_SHORTNAME.map(function (npl) { return [npl.name, npl]; }), true));
export var getByName = function (name) {
    return LENDER_DICTIONARY[name];
};
//# sourceMappingURL=Lenders.js.map